import React, { useEffect } from 'react';
import { useContext } from 'react';
import { ThemeContext } from '../contexts/ThemeContext';
import { LanguageContext } from '../contexts/LanguageContext';
import { ElementCard } from '../components/ElementCard/ElementCard';
import { Box } from '@mui/material';
import ElementCardGroup from '../components/ElementCard/ElementCardGroup';
import { globalBuilder } from '../../archbuilder/GlobalBuilder';

export const AboutMe: React.FC = () => {
  const { theme, setThemes } = useContext(ThemeContext);
  const { t } = useContext(LanguageContext);

  let turnOfLeft = false;

  const getTurn = () => {
    turnOfLeft = !turnOfLeft;
    return turnOfLeft;
  };

  useEffect(() => {
    setThemes(['pages', 'topbar', 'elementcards']);
  }, []);

  const attributesList1 = [
    {
      name: t('about_me_page/sex_age_etc/title'),
      content: t('about_me_page/sex_age_etc/content'),
    },
  ];

  const attributesList2 = [
    {
      name: t('about_me_page/hardskills/title'),
      content: t('about_me_page/hardskills/content'),
    },
  ];

  const attributesList3 = [
    {
      name: t('about_me_page/softskills/title'),
      content: t('about_me_page/softskills/content'),
    },
  ];

  const attributesList4 = [
    {
      name: t('about_me_page/availability/title'),
      content: t('about_me_page/availability/content'),
    },
  ];

  const attributesList5 = [
    {
      name: t('about_me_page/languages/title'),
      content: t('about_me_page/languages/content'),
    },
  ];

  const attributesList6 = [
    {
      name: t('about_me_page/residence/title'),
      content: t('about_me_page/residence/content'),
    },
  ];

  return globalBuilder.AboutMe(
    attributesList1,
    attributesList2,
    attributesList3,
    attributesList4,
    attributesList5,
    attributesList6,
    getTurn,
  );
};
